import type { CourseVideoProbe } from '@loamify/core-domain';
import { shouldCompressCourseVideo } from '@loamify/core-domain';

export async function probeVideoFile(file: File): Promise<CourseVideoProbe> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    const objectUrl = URL.createObjectURL(file);
    video.onloadedmetadata = () => {
      resolve({
        durationSec: Number.isFinite(video.duration) ? video.duration : 0,
        width: video.videoWidth,
        height: video.videoHeight,
        sizeBytes: file.size,
        mimeType: file.type || 'video/mp4',
      });
      URL.revokeObjectURL(objectUrl);
    };
    video.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Could not read video metadata'));
    };
    video.src = objectUrl;
  });
}

export function shouldCompressVideoFile(probe: CourseVideoProbe): boolean {
  return shouldCompressCourseVideo(probe);
}

export type UploadProgressPhase = 'probing' | 'compressing' | 'uploading' | 'confirming' | 'done';

export type UploadProgress = {
  phase: UploadProgressPhase;
  percent: number;
  label: string;
};
